import React from 'react';
import '../../style/video-react.css';
import { Player } from 'video-react';

export default ({ intl, dispatch, loading }) => {
  return (
    <div className="container-box">
      <Player
        playsInline
        autoPlay={true}
        src="https://media.w3.org/2010/05/sintel/trailer_hd.mp4"
      />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/player/JsPlayer.js